<template>
    <form class="form">
        <div class="mb-4">
            <div class="input-group">

                <div class="">
                    <form
                        @submit.prevent="submitForm"
                        id="payment-form"
                    >

                        <div
                            v-if="paymentError"
                            class="mt-4 rounded bg-danger-light p-2 text-[14px] font-semibold text-danger-darker"
                        >
                            {{ paymentError }}
                        </div>

                        <div
                            id="payment-element"
                            class="bg-center bg-no-repeat"
                        >
                            <!-- Elements will create form elements here -->
                        </div>
                    </form>
                </div>

            </div>
        </div>

        <div class="flex gap-4 justify-end">
            <span class="btn btn-outline" @click="cancel">Cancel</span>
            <button
                @click="submitForm"
                v-if="!submittingCardInfo"
                class="btn btn-primary"
            >
                Update Card
            </button>
            <span
                v-else
                class="btn btn-secondary opacity-50"
            >
                Please wait, updating card info...
            </span>
        </div>

    </form>
</template>
<script>

const stripe = Stripe(window.stripeKey);


export default {
    name: 'user-change-payment-card',
    props: {},
    data() {
        return {
            user: this.$page.props.auth.user,
            cardInfo: this.$page.props.auth.user.stripe_card_meta,
            stripePublicKey: window.stripeKey,
            stripeToken: null,
            paymentError: null,
            stripElements: null,
            cardElement: null,
            stripeSetupIntentClientSecret: null,
            submittingCardInfo: false,
            form: this.$inertia.form({
                billingEmail: this.$page.props.auth.user.email,
                billingFullName:
                    this.$page.props.auth.user.first_name + " " + this.$page.props.auth.user.last_name,
                billingStreet: null,
                billingCity: this.$page.props.auth.user.city,
                billingState: this.$page.props.auth.user.state,
                billingPostalCode: null,
            }),
        };
    },
    methods: {
        cancel() {
            this.$parent.$refs.updateCardInformationModal.closeModal();
        },
        setupPaymentElement() {

            let vm = this;
            let stripeOptions = {
                clientSecret: vm.stripeSetupIntentClientSecret,
                appearance: {
                    theme: "none",
                    labels: "above",
                    variables: {
                        colorPrimary: "#0D7AD9",
                        colorBackground: "#F2F0F0",
                        colorText: "#343434",
                        colorDanger: "#df1b41",
                        fontFamily: "Ideal Sans, system-ui, sans-serif",
                        spacingUnit: "2px",
                        borderRadius: "3px",
                        fontSizeBase: "18px",
                        spacingGridColumn: "16px",
                        spacingGridRow: "16px",
                    },
                    rules: {
                        ".Label": {
                            fontWeight: 600,
                        },
                        ".Label--resting": {
                            color: "#8C969C",
                        },
                        ".Label--floating": {
                            color: "#8C969C",
                            fontSize: "12px",
                        },
                        ".Input": {
                            color: "#121212",
                            padding: ".5rem",
                            paddingLeft: ".75rem",
                        },
                        ".Error": {
                            fontSize: "14px",
                        },
                    },
                },
            };

            this.stripElements = stripe.elements(stripeOptions);
            this.paymentElement = this.stripElements.create("payment");

            this.paymentElement.mount("#payment-element");

        },
        submitForm() {
            let vm = this;

            if (this.submittingCardInfo) {
                return;
            } else {
                this.submittingCardInfo = true;
            }

            this.confirmSetup().then(function (result) {
                if (result.error) {
                    if (
                        result.error.type === "card_error" ||
                        result.error.type === "validation_error"
                    ) {
                        vm.paymentError = result.error.message;
                    } else {
                        vm.paymentError =
                            "An unexpected error occurred. Please try again later.";
                    }
                }

                vm.submittingPayment = false;
            });
        },
        async confirmSetup() {
            let confirmParams = {
                payment_method_data: {
                    billing_details: {
                        name: this.user.first_name + " " + this.user.last_name,
                        email: this.user.email,
                        phone: null,
                        postal_code: null,
                        address: {
                            line1: this.form.billingStreet,
                            city: this.form.billingCity,
                            state: this.form.billingState,
                            postal_code: this.form.billingPostalCode,
                            country: "US",
                        },
                    },
                },
                return_url:
                    window.siteDomain + "/finalize-update-payment-method/" + this.user.id,
            };

            if (this.showAdditionalBillingFields) {
                confirmParams.shipping = {
                    name: this.user.first_name + " " + this.user.last_name,
                    address: {
                        line1: this.form.billingStreet,
                        city: this.form.billingCity,
                        state: this.form.billingState,
                        postal_code: this.form.billingPostalCode,
                        country: "US",
                    },
                };
            }

            let elements = this.stripElements;

            let result = stripe.confirmSetup({
                elements,
                confirmParams: confirmParams,
            });

            return result;
        },
    },
    mounted() {

        let vm = this;

        axios.get(route('prepare-update-payment-method')).then(function (response) {
            vm.stripeSetupIntentClientSecret = response.data.setup_intent_client_secret;
            vm.setupPaymentElement();
        })


    }
}
</script>
